/* eslint-disable react/destructuring-assignment */
import React, { SVGProps } from 'react';

function ReferralSentIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="68" height="68" viewBox="0 0 68 68" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect width="68" height="68" rx="7" fill="#D7F1FF" />
      <mask id="mask0_870_1067" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="13" y="13" width="42" height="42">
        <rect x="13.6" y="13.6" width="40.8" height="40.8" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_870_1067)">
        <path d="M21.7033 45.4286C21.1897 45.6338 20.7025 45.5902 20.2415 45.2978C19.7806 45.0054 19.5501 44.5795 19.5501 44.0201V36.8441L31.3192 34L19.5501 31.1558V23.9799C19.5501 23.4204 19.7806 22.9945 20.2415 22.7021C20.7025 22.4097 21.1897 22.3661 21.7033 22.5713L45.4291 32.5746C46.0612 32.8577 46.3772 33.3339 46.3772 34.0031C46.3772 34.6723 46.0612 35.1463 45.4291 35.4253L21.7033 45.4286Z" fill="#1A92FF" />
      </g>
    </svg>
  );
}

export default ReferralSentIcon;
